import { history } from '../utils/history';
import notification from './notifications-service';
import logger from './logger-service';

export default {
  notification,
  history,
  logger,
};
